'use strict';

// This was part of KayleeRoles, but was pulled out to avoid circular require
// dependencies in KayleeController.

var sutl = require('../sutl/Sutl');

var KayleeIsRole = {
    isRole: isRole,
};

function isRole(user, node, role) {
    if ((typeof node === 'undefined' || node === null) &&
        sutl.getNode(user, [ 'roles', 'role' ]) <= role) {
        return true;
    } else if (node.$nodeType === 'company' &&
        (sutl.getNode(user, [ 'roles', 'role' ]) <= role ||
         sutl.getNode(user, [ 'roles', 'companies', node.$id, 'role' ]) <= role)) {
        return true;
    } else if (node.$nodeType === 'site' &&
        (sutl.getNode(user, [ 'roles', 'role' ]) <= role ||
         sutl.getNode(user, [ 'roles', 'companies', node.companyId, 'role' ]) <= role ||
         sutl.getNode(user, [ 'roles', 'companies', node.companyId, 'sites', node.$id, 'role' ]) <= role)) {
        return true;
    } else if (node.$nodeType === 'room' &&
        (sutl.getNode(user, [ 'roles', 'role' ]) <= role ||
         sutl.getNode(user, [ 'roles', 'companies', node.companyId, 'role' ]) <= role ||
         sutl.getNode(user, [ 'roles', 'companies', node.companyId, 'sites', node.siteId, 'role' ]) <= role ||
         sutl.getNode(user, [ 'roles', 'companies', node.companyId, 'sites', node.siteId, 'rooms', node.$id, 'role']) <= role)) {
        return true;
    }

    return false;
}

module.exports = KayleeIsRole;
